import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Icon, Image } from 'semantic-ui-react';
import { TextField, Tooltip, IconButton } from 'material-ui';

import { tagNameAsyncValidate } from 'libs/validation';
import * as common from 'libs/commonFunc';
import {
  TagInitial,
  ModalTagAdd,
  ModalTagDelete,
  ModalTagAllDelete,
  TagColorDropdown,
  Loading,
  Button
} from 'components';
import Scrollbar from 'libs/Scrollbar';

import styles from './Tag.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class Tag extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      tagInitialOrdering,
      tagInitial,
      tagDataByTagNo,
      currentTag,
      isModal,
      isEditMode,
      isClicked,
      isAllOpen,
      isLoading,
      color,
      onCheckColorAdd,
      onClickTag,
      onAddTag,
      onDeleteTag,
      onDeleteAllTag,
      onCheckOrTag,
      onCheckAndTag,
      onToggleModal,
      onToggleTagEdit,
      onToggleTagInitial,
      onToggleDeleteAllTag,
      onSearchTag,
      onCheckColorEdit,
      // 태그 검색
      searchProps,
      tagItemProp,
      // 태그 카운트 표기 여부
      noTagCount,
      currentPath
    } = this.props;

    const tagComponent = tagInitialOrdering.map(
      // 컴포넌트로 매핑
      key => (
        <TagInitial
          key={key}
          initialKey={key}
          tagInitial={tagInitial.getIn([String(key), 'tagItemList'])}
          isView={tagInitial.getIn([String(key), 'isView'])}
          currentTag={currentTag}
          isModal={isModal}
          isEditMode={isEditMode}
          color={color}
          onCheckColorAdd={onCheckColorAdd}
          onClickTag={onClickTag}
          onToggleModal={onToggleModal}
          onToggleTagInitial={onToggleTagInitial}
          // 태그 개별 컴포넌트로 전달
          tagItemProp={tagItemProp}
          noTagCount={noTagCount}
        />
      )
    );

    return (
      <div className={cx('Tag-wrapper')}>
        {/* 태그 추가 모달 */}
        {isModal === 'tagAdd' && (
          <ModalTagAdd
            visible
            isClicked={isClicked}
            onAddTag={onAddTag}
            onToggleModal={onToggleModal}
            color={color}
            onCheckColorAdd={onCheckColorAdd}
          />
        )}
        {/* 태그 삭제 모달 */}
        {isModal === 'tagDelete' && (
          <ModalTagDelete
            visible
            isClicked={isClicked}
            onDeleteTag={onDeleteTag}
            onToggleModal={onToggleModal}
            selectedTag={tagDataByTagNo.get(String(currentTag.getIn(['isEditData', 'tagNo'])))}
          />
        )}
        {/* 태그 삭제 모달 */}
        {isModal === 'tagAllDelete' && (
          <ModalTagAllDelete
            visible
            isClicked={isClicked}
            onDeleteAllTag={onDeleteAllTag}
            onToggleModal={onToggleModal}
            tagAllCount={tagDataByTagNo.size}
          />
        )}
        <div className={cx('tag-title')}>
          {isLoading && (
            <div className={cx('Loading')}>
              <Loading content={'Loading...'} />
            </div>
          )}
          <div className={cx('tag-title-inner')}>
            <div>
              {defineMessages(formatMessage({ id: 'Tag_1', defaultMessage: '태그' }))}

              <div className={cx('tag-title-bt-area')}>
                <Tooltip
                  title={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                  placement="bottom">
                  <Image
                    src="/img/target/ico_search.png"
                    className={cx('bt-tagFunc', { selected: searchProps.isSearchActive })}
                    onClick={searchProps.onSearchActive}
                  />
                </Tooltip>
                <Tooltip
                  title={defineMessages(formatMessage({ id: 'Tag_2', defaultMessage: '태그를 여러개 선택(OR 조건)' }))}
                  classes={{ tooltip: 'tooltip-noMaxWidth' }}
                  placement="bottom">
                  <Image
                    src="/img/target/ico_tag_or.png"
                    className={cx('bt-tagFunc', { selected: currentTag.get('isMultiSelect') })}
                    onClick={onCheckOrTag}
                  />
                </Tooltip>
                {!currentPath.includes('/main/declaration') &&
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Tag_10', defaultMessage: '태그를 여러개 선택(AND 조건)' }))}
                    classes={{ tooltip: 'tooltip-noMaxWidth' }}
                    placement="bottom">
                    <Image
                      src="/img/target/ico_tag_and.png"
                      className={cx('bt-tagFunc', { selected: currentTag.get('isMultiAndSelect') })}
                      onClick={onCheckAndTag}
                    />
                  </Tooltip>}
                <Tooltip
                  title={defineMessages(formatMessage({ id: 'Tag_3', defaultMessage: '만들기' }))}
                  placement="bottom">
                  <Image
                    src="/img/target/ico_make.png"
                    className={cx('bt-tagFunc mr-4')}
                    onClick={() => {
                      onToggleModal('tagAdd');
                    }}
                  />
                </Tooltip>
                <Tooltip
                  title={defineMessages(formatMessage({ id: 'Tag_4', defaultMessage: '편집' }))}
                  placement="bottom">
                  <Image
                    src="/img/target/ico_modify.png"
                    className={cx('bt-tagFunc', { selected: isEditMode })}
                    onClick={onToggleTagEdit}
                  />
                </Tooltip>
                <Tooltip
                  title={
                    !!isAllOpen
                      ? defineMessages(formatMessage({ id: 'Tag_5', defaultMessage: '전체 닫기' }))
                      : defineMessages(formatMessage({ id: 'Tag_6', defaultMessage: '전체 열기' }))
                  }
                  classes={{ tooltip: 'tooltip-noMaxWidth' }}
                  placement="bottom">
                  <IconButton
                    color="primary"
                    className={cx('bt-toggleAllView')}
                    onClick={e => {
                      e.stopPropagation();
                      onToggleTagInitial();
                    }}>
                    <Image src={!!isAllOpen ? '/img/target/ico_close.png' : '/img/target/ico_open.png'} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            {searchProps.isSearchActive && (
              <div className={cx('search-area')}>
                <TextField
                  autoFocus
                  className={cx('input-search')}
                  value={searchProps.searchText}
                  onChange={searchProps.onChangeSearch}
                  onKeyUp={searchProps.onKeyupSearch}
                />
                <Button
                  className={cx('bt-icon')}
                  icon
                  title={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                  size="small"
                  onClick={e => {
                    e.stopPropagation();
                    searchProps.onSearch();
                  }}>
                  <Icon name="search" />
                </Button>
                <Button
                  className={cx('bt-icon')}
                  icon
                  title={defineMessages(formatMessage({ id: 'TagItem_2', defaultMessage: '취소' }))}
                  size="small"
                  onClick={e => {
                    e.stopPropagation();
                    searchProps.onClearSearch();
                  }}>
                  <Icon name="cancel" />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className={cx('tag-content')}>
          <Scrollbar autoHide color="white">
            <div className={cx('tag-content-inner')}>
              <div
                className={cx('bt-tag all-tag', { selectedTag: currentTag.get('selectedTag').get(0) === 'all-tag' })}
                onClick={e => {
                  onClickTag('all-tag');
                }}>
                {defineMessages(formatMessage({ id: 'Tag_7', defaultMessage: '모든 대상자' }))}
              </div>
              <div className={cx('each-tag')}>{tagComponent}</div>
              <div
                className={cx('bt-tag no-tag', { selectedTag: currentTag.get('selectedTag').get(0) === 'no-tag' })}
                onClick={e => {
                  onClickTag('no-tag');
                }}>
                {defineMessages(formatMessage({ id: 'Tag_8', defaultMessage: '태그가 없는 대상자' }))}
              </div>
              <TagColorDropdown currentTag={currentTag} onCheckColorEdit={onCheckColorEdit} />

              <Button
                className={cx('bt-delete-all-tag')}
                title={defineMessages(formatMessage({ id: 'ModalTagAllDelete_1', defaultMessage: '모든 태그 삭제' }))}
                size="small"
                onClick={onToggleDeleteAllTag}>
                {defineMessages(formatMessage({ id: 'ModalTagAllDelete_1', defaultMessage: '모든 태그 삭제' }))}
              </Button>
            </div>
          </Scrollbar>
        </div>
      </div>
    );
  }
}

Tag.propTypes = {
  tagInitial: ImmutablePropTypes.mapContains({}),
  currentTag: ImmutablePropTypes.mapContains({
    tagNo: 0,
    tagName: '',
    tagInitial: '',
    createUser: 0,
    color: '',
    isDropdown: ImmutablePropTypes.mapContains({
      isView: false,
      top: 0,
      left: 0
    }),
    isTagNameEdit: false
  }),
  isModal: PropTypes.string,
  isEditMode: PropTypes.bool,
  onClickTag: PropTypes.func,
  onAddTag: PropTypes.func,
  onDeleteTag: PropTypes.func,
  onToggleModal: PropTypes.func,
  onToggleTagEdit: PropTypes.func,
  onToggleTagInitial: PropTypes.func,
  onCheckColorEdit: PropTypes.func
};

const mapStateToProps = (state, { currentTag }) => {
  return {
    initialValues: {
      tagName: currentTag.getIn(['isEditData', 'tagName']) !== '' && currentTag.getIn(['isEditData', 'tagName'])
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formTagEdit',
    enableReinitialize: true,
    asyncValidate: tagNameAsyncValidate,
    asyncBlurFields: ['tagName'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(Tag))
);



// WEBPACK FOOTER //
// ./src/script/components/tag/Tag.js